import { useApi } from '@/@diffrag/hooks/useApi'
import { useQueryValue } from '@/@diffrag/hooks/useQueryValue'
import { ContentView } from '@/@diffrag/layout/ContentView'
import { SimpleTable } from '@/@diffrag/table/SimpleTable'
import { api } from '@/api'
import { IAdminUserROO1 } from 'api'
import { useNavigate } from 'react-router-dom'

export default function UserAdmin() {
  const navigate = useNavigate()
  const { data, isFetching, refetch } = useApi({
    id: 'adminList',
    fn: api().admin.getAdmins,
  })

  const onDelete = async (rows: IAdminUserROO1[]) => {
    await Promise.all(
      rows.map((row) => api().admin.deleteAdmin(row.id.toString())),
    )
    refetch()
  }

  return (
    <ContentView>
      <SimpleTable
        createHref="/admin/edit"
        totalCount={data?.length}
        options={{
          disableSearch: true,
        }}
        onDelete={onDelete}
        onRowClick={(row) => {
          navigate(`/admin/edit?id=${row.id}`)
        }}
        columns={[
          {
            label: '아이디',
            key: 'username',
            isPrimary: true,
          },
          {
            label: '이름',
            key: 'name',
            isPrimary: true,
          },
        ]}
        data={data}
        isLoading={isFetching}
      />
    </ContentView>
  )
}
